"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.fetchResponse = fetchResponse;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _fetch = require("./fetch");

/**
 * Helper function for creating a custom fetch response. Useful for mocking.
 */
function fetchResponse() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? '' : _ref$url,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? 200 : _ref$status,
      _ref$headers = _ref.headers,
      headers = _ref$headers === void 0 ? {} : _ref$headers,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", '');

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })) : _ref$text,
      _ref$json = _ref.json,
      json = _ref$json === void 0 ? /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", null);

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })) : _ref$json,
      _ref$arrayBuffer = _ref.arrayBuffer,
      arrayBuffer = _ref$arrayBuffer === void 0 ? /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Uint8Array());

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })) : _ref$arrayBuffer;

  return {
    url: url,
    ok: Math.floor(status / 100) === 2,
    status: status,
    headers: new _fetch.Headers(headers),
    text: text,
    json: json,
    arrayBuffer: arrayBuffer
  };
}